import { IState } from '../../store';
import { TPageExtra } from '../../types';

export function getPriceExtra(state: IState): Partial<TPageExtra> | undefined {
  const {
    offerData: { priceInfo },
  } = state;

  if (!priceInfo || !priceInfo.pricePerSquareValue) {
    return undefined;
  }

  return {
    additional_price: priceInfo.pricePerSquareValue,
  };
}
